<template>
    <div class="o-mobile-map-qr poster-mobile-qr">
        <div class="poster-mobile-qr__info">
            <div 
                class="poster-mobile-qr__description"
                v-html="`Skanna QR-koden med mobilkameran<br/> för att få karta över SKHLM på mobilen`"
            />
        </div>
        <div class="poster-mobile-qr__icon"/>
        <div class="poster-mobile-qr__qr-background"/>
        <div class="poster-mobile-qr__qr-wrapper">
            <OQrCodeGenerator />
        </div>
    </div>
</template>

<script>
import OQrCodeGenerator from '../o-qr-code-generator/o-qr-code-generator'
export default {
    name: "OPosterMobileMapQR",
    components: {
        OQrCodeGenerator
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
